import {
  Button,
  createMuiTheme,
  MuiThemeProvider,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  deleteProductMarca,
  getProductMarcaById,
  postProductMarca,
  updateProductMarca,
} from "../../../../api/productMarca";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useSkeleton } from "../../../hooks/useSkeleton";

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyMarca() {
  return {
    descripcion: null,
    referencia: null,
  };
}

export default function EditProductMarcaPage() {
  const [marca, setMarca] = useState(getEmptyMarca());

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const marcaId = useParams().id;
  const history = useHistory();
  const location = useLocation();

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  const handleBack = () => {
    const prevTablePage = location.state?.page;

    history.push(
      `/marcas-productos${prevTablePage ? "?page=" + prevTablePage : ""}`
    );
  };

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!marcaId) {
      disableLoadingData();
      return;
    }
    getProductMarcaById(marcaId, loggedUser?.accessToken)
      .then((res) => {
        if (res.status === 200) {
          setMarca(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la marca.",
        });
        handleBack();
      });
  }, [marcaId, disableLoadingData, history]);

  function saveMarca() {
    if (!marcaId) {
      postProductMarca(marca, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "¡Guardada!",
              customMessage: "Marca guardada con éxito.",
            });
            handleBack();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar la marca.",
          });
        });
    } else {
      updateProductMarca(marcaId, marca, loggedUser?.accessToken)
        .then((res) => {
          if (res.status === 204) {
            alertSuccess({
              title: "¡Guardado!",
              customMessage: "Cambios guardados con éxito.",
            });
            handleBack();
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setMarca({ ...marca, [element]: event.target.value });
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          <CardHeader title="Marca de producto">
            <CardHeaderToolbar>
              <Button
                onClick={() => saveMarca()}
                variant="outlined"
                color="primary"
                style={{
                  marginRight: marcaId ? "20px" : "",
                }}
              >
                Guardar marca
              </Button>
              {marcaId && (
                <>
                  <MuiThemeProvider theme={theme}>
                    <Button
                      className="py-2"
                      onClick={() => setOpenConfirmDialog(true)}
                      variant="outlined"
                      color="secondary"
                    >
                      Eliminar marca
                    </Button>
                  </MuiThemeProvider>
                </>
              )}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <TextField
              id={`nombre`}
              label="Nombre"
              value={marca.nombre}
              onChange={handleChange("nombre")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
          </CardBody>
        </Card>
        <Button
          onClick={handleBack}
          variant="outlined"
          style={{ marginRight: "20px" }}
        >
          Atrás
        </Button>
        <Button
          onClick={() => saveMarca()}
          variant="outlined"
          color="primary"
          style={{ marginRight: marcaId ? "20px" : "" }}
        >
          Guardar marca
        </Button>
        {marcaId && (
          <>
            <MuiThemeProvider theme={theme}>
              <Button
                className="py-2"
                onClick={() => setOpenConfirmDialog(true)}
                variant="outlined"
                color="secondary"
              >
                Eliminar marca
              </Button>
            </MuiThemeProvider>

            <ConfirmDialog
              title={"¿Estás seguro de que quieres eliminar esta marca?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteProductMarca(marcaId, loggedUser?.accessToken)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "¡Eliminada!",
                        customMessage: "Marca eliminada con éxito",
                      });
                      handleBack();
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "No se ha podido eliminar la marca.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
